import firebase from 'firebase/compat/app'

import * as db from "../db";

  export const fetchCustomers = ( search: string, limit: number, client: firebase.firestore.DocumentReference) => db.fetchCustomers( search, limit, client)

  export const deleteCustomer = (id: string ) => db.deleteCustomer(id)
